'use client';

import * as React from 'react';

/**
 * Analytics hooks for the upsell tease surfaces. This package stays analytics-agnostic:
 * the app layer provides the handlers (PostHog capture) and every TeaseUpsell /
 * TeaseSurface below the provider reports through them. No provider = no-op.
 */
export interface TeaseAnalytics {
  /** A prompt became visible to the viewer (popover opened / banner shown). */
  onView: (surface: string) => void;
  /** The viewer clicked one of the prompt's links. */
  onClick: (surface: string, action: 'cta' | 'secondary', href: string) => void;
}

const TeaseAnalyticsContext = React.createContext<TeaseAnalytics | null>(null);

export const TeaseAnalyticsProvider = TeaseAnalyticsContext.Provider;

export function useTeaseAnalytics(): TeaseAnalytics | null {
  return React.useContext(TeaseAnalyticsContext);
}
